export function buildDownloadFilename(
  filename: string,
  now: Date = new Date(),
  ext: string = 'csv'
): string {
  const pad2 = (n: number) => n.toString().padStart(2, '0');
  const timestamp = [
    now.getFullYear(),
    pad2(now.getMonth() + 1),
    pad2(now.getDate()),
    pad2(now.getHours()),
    pad2(now.getMinutes()),
  ].join('');
  const parts: string[] = [filename, timestamp];
  const base = parts.join('_');

  if (!ext) return base;
  const dotExt = ext.startsWith('.') ? ext : `.${ext}`;
  const hasExt = filename.toLowerCase().endsWith(dotExt.toLowerCase());
  return hasExt ? base : `${base}${dotExt}`;
}
